import React, { useEffect, useState } from 'react';
import {
  Box, FormControl, InputLabel, Select, MenuItem,
  Button, Typography, Paper
} from '@mui/material';
import DirectionsCarIcon from '@mui/icons-material/DirectionsCar';
import SearchIcon from '@mui/icons-material/Search';
import axiosInstance from '../services/api';

const VehicleFilter = ({ onFilter }) => {
  const [brands, setBrands] = useState([]);
  const [models, setModels] = useState([]);
  const [seriesList, setSeriesList] = useState([]);
  const [selBrand, setSelBrand] = useState('');
  const [selModel, setSelModel] = useState('');
  const [selSeries, setSelSeries] = useState('');

  useEffect(() => {
    axiosInstance.get('/vehiclebrands').then(r => setBrands(r.data)).catch(() => {});
  }, []);

  const handleBrandChange = async (val) => {
    setSelBrand(val); setSelModel(''); setSelSeries(''); setSeriesList([]);
    if (val) {
      const r = await axiosInstance.get(`/vehiclemodels?brandId=${val}`);
      setModels(r.data);
    } else { setModels([]); }
  };

  const handleModelChange = async (val) => {
    setSelModel(val); setSelSeries('');
    if (val) {
      const r = await axiosInstance.get(`/vehicleseries?modelId=${val}`);
      setSeriesList(r.data);
    } else { setSeriesList([]); }
  };

  const handleSearch = () => {
    if (selSeries) onFilter({ type: 'series', id: selSeries });
    else if (selModel) onFilter({ type: 'model', id: selModel });
    else if (selBrand) onFilter({ type: 'brand', id: selBrand });
  };

  const handleReset = () => {
    setSelBrand(''); setSelModel(''); setSelSeries('');
    setModels([]); setSeriesList([]);
    onFilter(null);
  };

  return (
    <Paper elevation={2} sx={{ p: 2, mb: 3 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2 }}>
        <DirectionsCarIcon color="primary" />
        <Typography variant="subtitle1" fontWeight={700}>Aracıma Göre Bul</Typography>
      </Box>
      <Box sx={{ display: 'flex', gap: 1.5, flexWrap: 'wrap', alignItems: 'flex-end' }}>
        <FormControl size="small" sx={{ minWidth: 130 }}>
          <InputLabel>Marka</InputLabel>
          <Select label="Marka" value={selBrand} onChange={e => handleBrandChange(e.target.value)}>
            <MenuItem value="">Tümü</MenuItem>
            {brands.map(b => <MenuItem key={b.id} value={b.id}>{b.name}</MenuItem>)}
          </Select>
        </FormControl>
        <FormControl size="small" sx={{ minWidth: 130 }} disabled={!selBrand}>
          <InputLabel>Model</InputLabel>
          <Select label="Model" value={selModel} onChange={e => handleModelChange(e.target.value)}>
            <MenuItem value="">Tümü</MenuItem>
            {models.map(m => <MenuItem key={m.id} value={m.id}>{m.name}</MenuItem>)}
          </Select>
        </FormControl>
        <FormControl size="small" sx={{ minWidth: 160 }} disabled={!selModel}>
          <InputLabel>Seri / Nesil</InputLabel>
          <Select label="Seri / Nesil" value={selSeries} onChange={e => setSelSeries(e.target.value)}>
            <MenuItem value="">Tümü</MenuItem>
            {seriesList.map(s => (
              <MenuItem key={s.id} value={s.id}>
                {s.name} ({s.yearStart}–{s.yearEnd || '...'})
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <Button variant="contained" startIcon={<SearchIcon />} onClick={handleSearch} disabled={!selBrand}>
          Ara
        </Button>
        {(selBrand || selModel || selSeries) && (
          <Button variant="text" onClick={handleReset}>Temizle</Button>
        )}
      </Box>
    </Paper>
  );
};

export default VehicleFilter;
